import React, {Component} from "react"
import {withRouter} from "react-router-dom"
import "theme/scantex/style/Form.scss"

import FormCMS from "components/Form/FormCMS"

@withRouter
export default class FormPage extends Component {
  
  render() {
    const {history} = this.props
    let product = this.props.location.state && this.props.location.state.product
    let slug = this.props.match.params.slug
    return (
      <div className="mw7 center pt5 pb6">
        <FormCMS
          product={product} slug={slug} onSuccess={() =>{
          window.swal( translate("Daten übertragen"), translate("Vielen Dank für Ihre Anfrage."),
            "success" )
          history.push("/")
        }}/>
      </div>
    )
  }
}




// WEBPACK FOOTER //
// ./src/pages/form/FormPage.js